import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import Auth from '../Function/Auth';
import { toast, ToastContainer } from "react-toastify";

function Setting() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [tabelLoading, setTableLoading] = useState(false); 
  const [depositStatus, setDepositStatus] = useState("");
  const [sessionTime, setSessionTime] = useState("");
  const [withdrawStatus, SetWithdrawStatus] = useState("");
  const [withdrawType, setWithdrawType] = useState("");
  const [withdrawAddress, setWithdrawAddress] = useState("");
  const [withdrawKeys, setWithdrawKeys] = useState("");



  useEffect(() => {
    const fetchProfileData = async () => {
      console.log('Token ', authToken);
      try {
        const masterData = await fetch(`${baseurl}/client/master-data`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (masterData.status === 429) {
          console.error("Rate limit exceeded. Please try again later.");
          return; // Stop further processing
        }

        const data = await masterData.json();
        console.log('Master Data', data);

        if (data.status) {
          setDepositStatus(data.data['deposit_status']);
          setSessionTime(data.data['session_time']);
          SetWithdrawStatus(data.data['client_withdraw_status']);
          setWithdrawType(data.data['client_withdraw_type'])
          setWithdrawAddress(data.data['client_withdraw_address'])
          setTableLoading(true)
        } else {
          // Handle any error condition
        }
      } catch (error) {
        toast.error('Fetch error:', error);
        setTableLoading(true)
      }
    };

    fetchProfileData();
  }, []);


  const updateData = async ()=>{

    console.log(depositStatus, sessionTime, withdrawStatus,  withdrawType);
    

    const formData = { 
        deposit_status : depositStatus,
        session_time:sessionTime,
        wallet_time: sessionTime,
        client_withdraw_status: withdrawStatus,
        client_withdraw_type: withdrawType,
        client_withdraw_address: withdrawAddress,
        client_withdraw_key: withdrawKeys,
    };


    try {

        console.log('Form Data',formData);
        const masterDataUpdate = await fetch(`${baseurl}/client/update-master-data`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify(formData),
        });

        if (masterDataUpdate.status === 429) {
          console.error("Rate limit exceeded. Please try again later.");
          return; // Stop further processing
        }

        const updateData = await masterDataUpdate.json();

        if (updateData.status) {
          toast.success(updateData.message)
        } else {
          // Handle any error condition
          toast.error(updateData.message)
        }
      } catch (error) {
        toast.error('Fetch error:', error);
        setTableLoading(true)
      }
  }


  return (
    <>
    <Header>
     <Auth/>
     <ToastContainer/>
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Setting !</h4>
                
              </div>
            </div>
            {/* End Page Header */}
          
            <div className="row">
        
        <div className="col-xl-12 col-lg-12">
            <div className="card">
            {tabelLoading ? (
                <div className="body">
                    <div className="card-body">
                        <div className="mb-4 main-content-label">Master Setting</div>
                        <form className="form-horizontal">
                        <div className="form-group mb-3">
                            <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">Deposit Status</label>
                            </div>
                            <div className="col-md-9">
                                <select className="form-control" data-trigger="" name="choices-single-default" id="choices-single-default1" onChange={(e)=>setDepositStatus(e.target.value)}>
                                <option value={depositStatus || 'Select Status'}>{depositStatus || 'Select Status'}</option>
                                <option value={'active'}>Active</option>
                                <option value={'close'}>Close</option>
                                </select>
                            </div>
                            </div>
                        </div>
                        <div className="mb-4 main-content-label">Session Setting</div>
                        <div className="form-group mb-3">
                            <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">Session Time (Second)</label>
                            </div>
                            <div className="col-md-9">
                                <input type="number" value={sessionTime} className="form-control"   onChange={(e)=>setSessionTime(e.target.value)} placeholder="Set in second" defaultValue="Petey Cruiser"/>
                            </div>
                            </div>
                        </div>

                        <div className="mb-4 mt-4 main-content-label">Client Withdraw Setting</div>
                        <div className="form-group mb-3">
                            <div className="row">
                            <div className="col-md-3">
                                <label className="form-label"> Withdraw Status</label>
                            </div>
                            <div className="col-md-9">
                                <select className="form-control" data-trigger="" name="choices-single-default" id="choices-single-default1" onChange={(e)=> SetWithdrawStatus(e.target.value)}>
                                    <option value={withdrawStatus || 'select Status'}>{withdrawStatus || 'select Status'}</option>
                                    <option value={'enable'}>Enable</option>
                                    <option value={'disable'}>Disable</option>
                                </select>
                            </div>
                            </div>
                        </div>
                        <div className="form-group mb-3">
                            <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">Withdraw Type</label>
                            </div>
                            <div className="col-md-9">
                                <select className="form-control" data-trigger="" name="choices-single-default" id="choices-single-default1" onChange={(e)=>setWithdrawType(e.target.value)}>
                                    <option value={withdrawType || 'select Status'}>{withdrawType || 'select Status'}</option>
                                    <option value={'auto'}>auto</option>
                                    <option value={'manual'}>manual</option>
                                </select>
                            </div>
                            </div>
                        </div>

                        <div className="mb-4 main-content-label">Wallet  Setting</div>
                        <div className="form-group mb-3">
                            <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">Withdraw Address</label>
                            </div>
                            <div className="col-md-9">
                            <input type="text" value={withdrawAddress} className="form-control"   onChange={(e)=>setWithdrawAddress(e.target.value)} placeholder="Enter Wallet Address" defaultValue="Petey Cruiser"/>
                            </div>
                            </div>
                        </div>
                        <div className="form-group mb-3">
                            <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">Withdraw Wallet Key</label>
                            </div>
                            <div className="col-md-9">
                                <input type="text" value={withdrawKeys} className="form-control"   onChange={(e)=>setWithdrawKeys(e.target.value)} placeholder="Enter Wallet Keys" defaultValue="Petey Cruiser"/>
                            </div>
                            </div>
                        </div>


                        </form>
                    </div>
                    <div className="card-footer">
                        <button type="submit" className="btn btn-primary waves-effect waves-light" onClick={updateData}>
                            Update 
                        </button>
                    </div>
                </div>
              ):(
                <div className="card-body">
                     <div className="text-center">
                     <div class="d-flex justify-content-center mb-4">
                          <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading...</span>
                          </div>
                      </div>
                    </div>
                </div>    

              )}   


            </div>
        </div>
        </div>


          </div>
        </div>
        </Header>

      <Footer/>

    </>
  )
}

export default Setting